import NetPositionsUseCase from "@domains/features/PostLogin/useCases/NetPositionsUseCase";
import SaveIndicesUseCase from "@domains/features/PostLogin/useCases/SaveIndicesUseCase";
import ContributionUseCase from "@domains/features/PostLogin/useCases/ContributionUseCase";
import PortfolioCompositionUseCase from "@domains/features/PostLogin/useCases/PortfolioCompositionUseCases";
import IndexDetailsUseCase from "@domains/features/PostLogin/useCases/IndexDetailsUseCase";
import MarketMapPostLoginUseCase from "@domains/features/PostLogin/useCases/MarketMapPostLoginUseCase";
import ExploreTradingUseCase from "@domains/features/PostLogin/useCases/ExploreTraadeUseCase";
import ServiceListUseCase from "@domains/features/PostLogin/useCases/ServiceListUseCase";
import DiversifyPortfolioUseCase from "@domains/features/PostLogin/useCases/DiversifyPortfolio";
import AllIndicesListUseCase from "@domains/features/PostLogin/useCases/AllIndicesListUseCase";
import UpcomingEventsUseCase from "@domains/features/PostLogin/useCases/UpcomingEventsUseCase";
import NFOLiveUseCase from "@domains/features/PostLogin/useCases/NFOLiveUseCase";
import StreamUseCase from "@domains/useCases/StreamUsecase";
export default (function (repo) {
    return {
        postLogin: {
            positions: new NetPositionsUseCase(repo.postLogin),
            saveIndices: new SaveIndicesUseCase(repo.postLogin),
            porfolioComposition: new PortfolioCompositionUseCase(repo.postLogin),
            contribution: new ContributionUseCase(repo.postLogin),
            indexDetails: new IndexDetailsUseCase(repo.postLogin),
            marketMapPL: new MarketMapPostLoginUseCase(repo.postLogin),
            exploreTrading: new ExploreTradingUseCase(repo.postLogin),
            serviceList: new ServiceListUseCase(repo.postLogin),
            diversifyPortfolio: new DiversifyPortfolioUseCase(repo.postLogin),
            allIndicesList: new AllIndicesListUseCase(repo.postLogin),
            upcomingEvents: new UpcomingEventsUseCase(repo.postLogin),
            nfoLive: new NFOLiveUseCase(repo.postLogin),
        },
        quoteStream: new StreamUseCase(repo.quoteStream),
    };
});
